import { inject, injectable } from "inversify";
import { IMyDriversService } from "../models/IMyDriversService";
import { Types } from "@ioc/types";
import { IHttpService } from "@modules/infra/http/models/IHttpService";
import { DriversResponse } from "@pages/User/MyDrivers/models";

@injectable()
export class MyDriversService implements IMyDriversService {
  //@ts-ignore
  @inject(Types.IHttpService) private httpInstance: IHttpService;

  public getAllDrivers(
    page: number,
    driverQuery?: string,
    companyDocuments?: string
  ): Promise<DriversResponse> {
    const data = {
      driverQuery,
      companyDocuments,
    };

    for (let key in data) {
      if (!data[key]) {
        delete data[key];
      }
    }

    const response = this.httpInstance.get("/drivers/for-company", {
      params: {
        page,
        limit: 10,
        ...data,
      },
    });

    return response;
  }

  public updateDriverAssociations(
    driverId: string,
    data: { companyDocuments: string[] }
  ): Promise<void> {
    return this.httpInstance.put(`/drivers/${driverId}/bind`, data);
  }

  public downloadReport(
    driverQuery?: string,
    companyDocuments?: string
  ): Promise<Blob> {
    const data = { driverQuery, companyDocuments };

    for (let key in data) {
      if (!data[key]) {
        delete data[key];
      }
    }

    return this.httpInstance.get("/drivers/report/for-company", {
      params: data,
      responseType: "blob",
    });
  }
}
